export const getNormalizeString = (input: string | null | undefined): string => {
    return (input ?? '')
        .replace(/…/g, '...') // Normalize ellipses
        .replace(/‐|‑|—|–/g, '-') // Normalize hyphens
        .replace(/\s+/g, ' ') // Collapse multiple spaces
        .trim()
        .toLowerCase()
}
